// extracted by mini-css-extract-plugin
var _1 = "TableCellNote-moduleTableCellNote__Yb5FN";
var _2 = "TableCellNote-modulenoteText__Y4RyK";
export { _1 as "TableCellNote", _2 as "noteText" }
